import noordhoffLogo from "assets/images/png/noordhofflogo.png";
import { Button } from "components/Button";
import { NavigationDropdown } from "components/NavigationDropdown";
import { HOME_PAGES_ROUTES } from "constants/routes";
import { useProfile } from "hooks/useProfile";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useParams } from "react-router-dom";
import type { HeaderMenuProps, ParamsProps } from "./HeaderMenu.model";
import {
  StyleAnchor,
  StyleHeader,
  StyleLink,
  StyleLogo,
  StyleNavigation,
} from "./HeaderMenu.styled";

export const HeaderMenu: React.FC<HeaderMenuProps> = observer(({ dataCy, isTeacher }) => {
  const { t } = useTranslation("header");
  const { additionalsId } = useParams<ParamsProps>();

  const { fetchUserInfo, userInfo } = useProfile();
  const url = useHistory().location.pathname;
  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo]);

  return (
    <StyleHeader data-cy={dataCy}>
      <StyleNavigation>
        <Link to={HOME_PAGES_ROUTES.HOME_PAGE}>
          <StyleLogo alt="studiemeister-logo" src={noordhoffLogo} />
        </Link>
        <StyleAnchor data-cy="return-to-main-stm-app-link" href={window.location.origin}>
          <Button
            height={40}
            itemId="studiemeister-dashboard-button"
            module="overview-header"
            variant="secondary"
            width={200}
          >
            {t("btnBack")}
          </Button>
        </StyleAnchor>
      </StyleNavigation>
      <StyleNavigation>
        {isTeacher && (
          <StyleLink to={`/preview/${additionalsId}`}>
            <Button
              height={40}
              itemId="overview-button"
              module="overview-header"
              variant="secondary"
              width={200}
            >
              {t("btnViewmaterial")}
            </Button>
          </StyleLink>
        )}
        {url.includes("preview") && (
          <StyleLink to={`/${additionalsId}`}>
            <Button
              height={40}
              itemId="overview-button"
              module="overview-header"
              variant="secondary"
              width={200}
            >
              {t("back")}
            </Button>
          </StyleLink>
        )}
        {userInfo && <NavigationDropdown userInfo={userInfo} />}
      </StyleNavigation>
    </StyleHeader>
  );
});
